// utils/sanitize.js
import DOMPurify from 'dompurify';

export function sanitizeHtml(html) {
  if (!html) return '';

  try {
    // check agar browser environment me chal raha hai
    if (typeof window !== 'undefined' && DOMPurify.sanitize) {
      return DOMPurify.sanitize(String(html), { USE_PROFILES: { html: true } });
    }
  } catch (e) {
    console.warn('DOMPurify error:', e);
  }

  // fallback — agar DOM available nahi hai ya sanitize fail ho gaya
  return String(html)
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
    .replace(/\{/g, '&#123;')
    .replace(/\}/g, '&#125;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/%/g, '&#37;');
}

export function sanitizeContent(str) {
  if (!str) return '';
  return str
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
    .replace(/\}/g, '&#125;')
    .replace(/\{/g, '&#123;')
    .replace(/[""]/g, '"')
    .replace(/['']/g, "'")
    .replace(/©/g, '&copy;')
    .replace(/®/g, '&reg;')
    .replace(/™/g, '&trade;');
}
